<template>
  <div className="container">
    <h1>Send SMS</h1>
    <div className="row">
      <div className="col margin-bottom-1">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
        <sdx-validation-message v-if="showApplicationValidationMessage()"
                                validation-message="Please choose an application"></sdx-validation-message>
      </div>
    </div>
    <div className="row" v-if="envService.featureToggleSmsTag()">
      <div className="col margin-bottom-2">
        <span class="sdx-like-label" style="padding-right: 5px">Tag</span>
        <sdx-menu-flyout>
          <sdx-menu-flyout-toggle>
            <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
          </sdx-menu-flyout-toggle>
          <sdx-menu-flyout-content style="width: 600px;">
            <p>
              {{ $t('commons.tag') }}
            </p>
          </sdx-menu-flyout-content>
        </sdx-menu-flyout>
        <sdx-input
            data-testid="tag"
            name="inputTag"
            className="sdx-input"
            placeholder="tag1,tag2"
            :value="tag"
            @input="(event) => setTag(event)"></sdx-input>
      </div>
    </div>

    <div className="row">
      <div className="col margin-bottom-1">
        <sdx-input
            data-testid="phoneNumber"
            name="inputPhoneNumber"
            label="Phone Number"
            className="sdx-input"
            placeholder="+4179..."
            :value="phoneNumber"
            @input="(event) => setPhoneNumber(event)"
            :validation-message="showPhoneNumberValidationMessage() ? 'The number you entered is not a valid phone number' : ''"></sdx-input>
      </div>
    </div>
    <div className="row">
      <div className="col margin-bottom-2">
        <sdx-input
            data-testid="smsText"
            name="textSmsText"
            label="Text"
            type="textarea"
            className="sdx-input sdx-input-textarea"
            placeholder="..."
            :value="smsText"
            @input="(event) => setSmsText(event)"
            :validation-message="showSmsTextValidationMessage() ? 'Please enter a text' : ''"></sdx-input>
      </div>
    </div>
    <div className="row">
      <div className="col margin-bottom-1">
        <sdx-button-group className="align-left">
          <sdx-button
              data-testid="buttonNext"
              name="buttonNext"
              label="Next"
              :disabled="!this.validateForm()"
              @click="goToPreview()"></sdx-button>
        </sdx-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import {logger} from "@/services/logger.service";
import {isTextNotEmpty, validatePhoneNumber} from "@/util/utility";
import envService from "@/services/env.service";

export default {
  components: {
    DevAppDropDownComponent,
  },
  data() {
    return {
      webId: undefined,
      phoneNumber: sessionStorage.getItem('phoneNumber'),
      smsText: sessionStorage.getItem('smsText'),
      webIdChanged: false,
      phoneNumberChanged: false,
      smsTextChanged: false,
      tag: sessionStorage.getItem('tag'),
      tagChanged: false,
    };
  },
  mounted() {
    logger.debug("tag: " + this.tag)
  },
  methods: {
    devAppChanged: function (webId) {
      this.webIdChanged = true;
      this.webId = webId;
    },
    setPhoneNumber(event) {
      this.phoneNumberChanged = true;
      this.phoneNumber = event.srcElement.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    },
    setSmsText(event) {
      this.smsTextChanged = true;
      this.smsText = event.srcElement.value;
    },
    setTag(event) {
      this.tagChanged = true;
      this.tag = event.srcElement.value;
    },
    showApplicationValidationMessage() {
      return this.webIdChanged && !this.validateApplication();
    },
    showPhoneNumberValidationMessage() {
      return this.phoneNumberChanged && !validatePhoneNumber(this.phoneNumber);
    },
    showSmsTextValidationMessage() {
      return this.smsTextChanged && !isTextNotEmpty(this.smsText);
    },
    validateApplication() {
      logger.debug("validateApplication - application: " + this.webId);
      return this.webId !== undefined && this.webId !== null && this.webId !== '';
    },
    validateForm() {
      return this.validateApplication() && validatePhoneNumber(this.phoneNumber) && isTextNotEmpty(this.smsText);
    },
    goToPreview() {
      sessionStorage.setItem('sendSmsWebId', this.webId);
      sessionStorage.setItem('smsText', this.smsText);
      sessionStorage.setItem('phoneNumber', this.phoneNumber);
      if (this.tag)
        sessionStorage.setItem('tag', this.tag);

      this.$router.push('/sendsms/preview');
    },
  },
  computed: {
    envService() {
      return envService
    }
  }
}

</script>
